import { BOX_TYPES } from 'config';

import logoBlaBlaCar from 'assets/images/logos/blablacar-color.svg';

export const data = [
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'blablaImage',
      clientLogo: logoBlaBlaCar,
      title:
        'How to deal with rapid growth and the aggressive expansion of a startup.',
      tags: ['php', 'UX/UI', 'scrum'],
    },
    settings: {
      tileColor: 'white',
      link: '/blog/case-story-blablacar/',
    },
    id: 'box-BlaBlaCar',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'virginImage',
      clientLogo: 'logoVirgin',
      title: 'How to deliver and launch a mobile and web MVP in just 4 weeks.',
      tags: ['ReactJS', 'mobile', 'agile'],
    },
    settings: {
      tileColor: 'mine-shaft',
      textColor: 'white',
      link: '/blog/case-study-virgin-radio-oman/',
    },
    id: 'box-virgin-radio-oman',
  },
  {
    type: BOX_TYPES.TESTIMONIAL,
    content: {
      image: 'logoIonoview',
      testimonial:
        '<q>Boldare is very experienced. They are acutely aware of the latest standards and most current technologies.</q>',
      caption: {
        author: 'Issam Najm',
        position: 'CTO Iono View',
      },
      tags: ['symfony', 'microservices', 'saas'],
    },
    settings: {
      tileColor: 'red',
      theme: 'light',
      link: '/blog/case-study-ionoview/',
      id: 'box-ionoview',
    },
  },
  {
    type: BOX_TYPES.HASHTAG,
    content: 'machine<br />learning',
    background: 'machineLearning',
    link: '/blog/machine-learning-content-moderation/',
    id: 'box-machineLearning',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'eresImage',
      clientLogo: 'logoEres',
      title:
        'How to successfully transition from a physical business to digital service.',
      tags: ['workshops', 'webdesign', 'consulting'],
    },
    settings: {
      tileColor: 'rodeo-dust',
      textColor: 'white',
      link: '/blog/case-study-eres-yachting-booking-platform/',
    },
    id: 'box-eres',
  },
];
